<template>
  <span>
      <a href="#" @click="openSendEmailModal()"class="btn">Send Email</a>
      <vehicle-recommendation-send-email-modal
              :selectedVehicles = this.vehicleId
              :getAllVehicles = this.loadVehicles
      ></vehicle-recommendation-send-email-modal>
  </span>
</template>
<script>

    import { mapState, mapActions } from 'vuex'
    import {objLookup} from '../util/common'

    export default {
        props: [
            'vehicle_id'
        ],
        data() {
            return {
               vehicleId: []
            }
        },
        mounted() {
            this.getVehicleId()
        },
        computed: {
            ...mapState({
                loadVehicles: state => state.loadVehicleForEmail.all,
            })
        },
        methods: {
            openSendEmailModal(){
                $('#sendEmail').modal('show');
                this.$store.dispatch('loadVehicleForEmail/getVehicle', {
                    vehicle_ids: [this.vehicle_id],
                });

            },
            getVehicleId(){
                this.vehicleId.push(this.vehicle_id)
            }

        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/SendEmail.vue